<template>
	<div class="search">
		<div class="intro">Search by Compound Structure</div>
		<el-form ref="form" :inline="true" :model="form" label-width="80px">
			<el-form-item label="Structure:" class="label">
				<el-col :span="8">
					<el-input placeholder="Input SMILES,if there are multiple SMILES,please use ',' segmente"
						style="width:600px;" :autosize="{ minRows:1, maxRows:100 }" v-model.trim="form.structure">
					</el-input>
				</el-col>

			</el-form-item>

			<el-form-item>
				<el-col>
					<el-upload class="upload-demo" :action="'http://39.104.56.4:5000/api/uploader'"
						:on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
						:on-exceed="handleExceed" :on-success="onSuccess" :file-list="fileList" :multiple="false"
						:limit="1" :before-upload="beforeUpload">
						<el-button plain type="primary" size="medium" icon="el-icon-upload2">mol2/SDF Upload</el-button>
					</el-upload>
				</el-col>
			</el-form-item>

			<el-form-item label="Name:">
				<el-input v-model.trim="form.name"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="onSubmit">Search</el-button>
			</el-form-item>
		</el-form>

		<el-table :data="showData" v-loading="loading" stripe border fit style="width:100%;min-height:300px;font-size: 18px;"
			empty-text="No Data">
			<!-- <el-table-column type="index"> </el-table-column> -->
			<el-table-column prop="Inflam_id" label="InflamNat ID" width="130px">
				<template slot-scope="scope">
					<el-link type="primary" @click="toDetail(scope.row.id)" style="font-size: 18px;">{{scope.row.Inflam_id}}</el-link>
				</template>
			</el-table-column>
			<el-table-column prop="Name" label="Name" width="130px"> </el-table-column>
			<el-table-column prop="SMILES" label="SMILES" width="450px"> </el-table-column>
			<el-table-column prop="MW" label="Molecular Weight" width="155px"></el-table-column>
			<el-table-column prop="img" label="Structure" width="130px">
				<template slot-scope="scope">
					<el-image style="width:100px; height: 100px" :src="scope.row.img" fit="fill"></el-image>
				</template>
			</el-table-column>

			<el-table-column fixed="right" label="Detail">
				<template slot-scope="scope">
					<el-button @click="toDetail(scope.row.id)" type="text" size="small" style="font-size: 18px;">Detail</el-button>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="Bioactivity" width="130px">
				<template slot-scope="scope">
					<el-button @click="toAbout(scope.row.id)" type="text" size="small" style="font-size: 18px;">Bioactivity</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-warp" style="font-size: 18px;">
			<el-pagination @current-change="currentChange" background layout="prev, pager, next"
				:total="tableData.length"  />
		</div>
		<div class="down-load">
			<el-button size="small" @click="downloadFile" type="success" round>Download</el-button>
		</div>
		<iframe v-show="false" :src="iframeurl" frameborder="0"></iframe>
	</div>
</template>

<script>
	export default {
		name: "search",
		data() {
			return {
				form: {
					structure: "",
					name: "",
				},
				tableData: [],
				currentNum: 1,
				loading: false,
				fileList: [],
				iframeurl: "",
			};
		},
		computed: {
			showData() {
				let tableList = this.tableData.concat([]);
				return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);
			},
		},
		methods: {
			onSubmit() {
				this.loading = true;
				this.currentNum = 1;
				this.tableData = [];
				this.$http({
					url: "/api/rdkit/queryBySmiles",
					params: this.form,
					method: "get",
				}).then((res) => {
					this.tableData = res.data.data;
					if (!this.tableData.length) {
						this.$message.warning("No compound matched");
					}
					this.loading = false;
				});
			},
			currentChange(num) {
				this.currentNum = num;
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			beforeUpload(file) {
				console.log(file)
				var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
				const extension = testmsg === 'sdf'
				const extension2 = testmsg === 'mol2'
				// const isLt2M = file.size / 1024 / 1024 < 10            
				if (!extension && !extension2) {
					this.$message({
						message: 'Upload files can only be in sdf, mol2 format!',
						type: 'warning'
					});
				}
				return extension || extension2
			},
			handleExceed(files, fileList) {
				// this.$message.warning(
				//   `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
				//     files.length + fileList.length
				//   } 个文件`
				// );
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`Sure to remove ${file.name}？(Only Upload files in sdf, mol2 format!)`);
			},
			onSuccess({
				data
			}) {
				this.form.structure = data.join(",");
			},
			down() {
				// const { structure, name } = this.form;
				// const res = await this.$http({
				//   method: 'get',
				//   url: '/api/exportCsv',
				//   params: { structure, name }
				// })
				// console.log(res)
				// this.iframeurl = `/api/exportCsv?structure=${structure}&name=${name}`
				const {
					structure,
					name
				} = this.form;
				this.iframeurl = `/api/exportCsv?structure=${structure}&name=${name}`;
			},
			async downloadFile() {
				const {
					structure,
					name
				} = this.form;
				const URL = `/api/exportCsv?structure=${structure}&name=${name}`
				const res = await this.$http.get(URL);
				const blob = new Blob([res.data], {
					type: res.headers['content-type']
				});
				let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
				let result = patt.exec(res.headers['content-disposition']);
				let filename = 'result.csv';

				const downloadElement = document.createElement('a');
				const href = window.URL.createObjectURL(blob);

				console.log(filename);
				downloadElement.style.display = 'none';
				downloadElement.href = href;
				downloadElement.download = filename; //下载后文件名
				document.body.appendChild(downloadElement);
				downloadElement.click(); //点击下载
				document.body.removeChild(downloadElement); //下载完成移除元素
				window.URL.revokeObjectURL(href); //释放掉blob对象
			},
			toDetail(id) {
				const {
					origin,
					pathname
				} = window.location;
				window.location.href = `${origin}${pathname}#/main/search/detail?id=${id}`;
				//   window.open(`${origin}${pathname}#/main/search/detail?id=${id}`);
			},

			toAbout(id) {
				const {
					origin,
					pathname
				} = window.location;
				window.location.href = `${origin}${pathname}#/main/search/about?id=${id}`;
				//   window.open(`${origin}${pathname}#/main/search/about?id=${id}`);
			},
		},
		mounted() {
			this.onSubmit()
		}
	};
</script>

<style scoped>

	.intro {
		margin: 0 0 20px 0;
		border-bottom: 2px solid rgb(245, 166, 20);
		line-height: 60px;
		text-align: center;
		font-size: 30px;
		color: #409EFF;
	}

	.page-warp {
		margin-top: 10px;
		display: flex;
		justify-content: center;
	}

	.down-load {
		display: flex;
		justify-content: flex-end;
	}

	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.search {
		padding: 0 100px;
		margin: 0 auto;
		
	}
</style>
<!--<template>-->
<!--  <div class="search">-->
<!--    <el-form ref="form" :inline="true" :model="form" label-width="100px">-->
<!--      <el-form-item label="Structure">-->
<!--        <el-col :span="11">-->
<!--          <el-input-->
<!--            placeholder="Input SMILES,if there are multiple SMILES,please use ',' segmente"-->
<!--            type="textarea"-->
<!--            style="width: 400px"-->
<!--            :autosize="{ minRows: 2, maxRows: 200 }"-->
<!--            v-model.trim="form.structure"-->
<!--          ></el-input>-->
<!--        </el-col>-->
<!--        <el-col>-->
<!--          <el-upload-->
<!--            class="upload-demo"-->
<!--            :action="'http://39.104.56.4:5000/api/uploader'"-->
<!--            :on-preview="handlePreview"-->
<!--            :on-remove="handleRemove"-->
<!--            :before-remove="beforeRemove"-->
<!--            :on-exceed="handleExceed"-->
<!--            :on-success="onSuccess"-->
<!--            :file-list="fileList"-->
<!--            :multiple="false"-->
<!--            :limit="1"-->
<!--          >-->
<!--            <el-button size="small">mol2/SDF Upload</el-button>-->
<!--          </el-upload>-->
<!--        </el-col>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="Name">-->
<!--        <el-input v-model.trim="form.name"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item>-->
<!--        <el-button type="primary" icon="el-icon-search" @click="onSubmit"-->
<!--          >Search</el-button-->
<!--        >-->
<!--      </el-form-item>-->
<!--    </el-form>-->
<!--    <el-table-->
<!--      :data="showData"-->
<!--      v-loading="loading"-->
<!--      stripe-->
<!--      border-->
<!--      fit-->
<!--      style="width: 100%"-->
<!--      empty-text="No Data"-->
<!--    >-->
<!-- <el-table-column type="index"> </el-table-column> -->
<!--      <el-table-column prop="Inflam_id" label="InflamNat ID">-->
<!-- <template slot-scope="scope">
<!--          <el-link type="primary" @click="toDetail(scope.row.id)">{{-->
<!--            scope.row.id-->
<!--          }}</el-link>-->
<!--        </template> -->
<!--      </el-table-column>-->
<!--      <el-table-column prop="Name" label="Name"> </el-table-column>-->
<!--      <el-table-column prop="SMILES" label="SMILES"> </el-table-column>-->
<!--      <el-table-column prop="MW" label="Molecular Weight"></el-table-column>-->
<!--      <el-table-column prop="img" label="Structure">-->
<!--        <template slot-scope="scope">-->
<!--          <el-image-->
<!--            style="width: 100px; height: 100px"-->
<!--            :src="scope.row.img"-->
<!--            fit="fill"-->
<!--          ></el-image>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column fixed="right" label="Detail">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button-->

<!--            @click="toDetail(scope.row.id)"-->
<!--            type="text"-->
<!--            size="small"-->
<!--            >Detail</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column fixed="right" label="Bioactivity">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button-->

<!--            @click="toAbout(scope.row.id)"-->
<!--            type="text"-->
<!--            size="small"-->
<!--            >Bioactivity</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--    </el-table>-->
<!--    <div class="page-warp">-->
<!--      <el-pagination-->
<!--        @current-change="currentChange"-->
<!--        background-->
<!--        layout="prev, pager, next"-->
<!--        :total="tableData.length"-->
<!--      />-->
<!--    </div>-->
<!--    <div class="down-load">-->
<!--      <el-button size="small" @click="downloadFile" type="success" round-->
<!--        >Download</el-button-->
<!--      >-->
<!--    </div>-->
<!--    <iframe v-show="false" :src="iframeurl" frameborder="0"></iframe>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--export default {-->
<!--  name: "search",-->
<!--  data() {-->
<!--    return {-->
<!--      form: {-->
<!--        structure: "",-->
<!--        name: "",-->
<!--      },-->
<!--      tableData: [],-->
<!--      currentNum: 1,-->
<!--      loading: false,-->
<!--      fileList: [],-->
<!--      iframeurl: "",-->
<!--    };-->
<!--  },-->
<!--  computed: {-->
<!--    showData() {-->
<!--      let tableList = this.tableData.concat([]);-->
<!--      return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);-->
<!--    },-->
<!--  },-->
<!--  methods: {-->
<!--    onSubmit() {-->
<!--      this.loading = true;-->
<!--      this.currentNum = 1;-->
<!--      this.tableData = [];-->
<!--      this.$http({-->
<!--        url: "/api/rdkit/queryBySmiles",-->
<!--        params: this.form,-->
<!--        method: "get",-->
<!--      }).then((res) => {-->
<!--        this.tableData = res.data.data;-->
<!--        if (!this.tableData.length) {-->
<!--          this.$message.warning("No compound matched");-->
<!--        }-->
<!--        this.loading = false;-->
<!--      });-->
<!--    },-->
<!--    currentChange(num) {-->
<!--      this.currentNum = num;-->
<!--    },-->
<!--    handleRemove(file, fileList) {-->
<!--      console.log(file, fileList);-->
<!--    },-->
<!--    handlePreview(file) {-->
<!--      console.log(file);-->
<!--    },-->
<!--    handleExceed(files, fileList) {-->
<!--// this.$message.warning(-->
<!--//   `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${-->
<!--//     files.length + fileList.length-->
<!--//   } 个文件`-->
<!--// );-->
<!--    },-->
<!--    beforeRemove(file, fileList) {-->
<!--      return this.$confirm(`Sure to remove ${file.name}？`);-->
<!--    },-->
<!--    onSuccess({ data }) {-->
<!--      this.form.structure = data.join(",");-->
<!--    },-->
<!--    down() {-->
<!--// const { structure, name } = this.form;-->
<!--// const res = await this.$http({-->
<!--//   method: 'get',-->
<!--//   url: '/api/exportCsv',-->
<!--//   params: { structure, name }-->
<!--// })-->
<!--// console.log(res)-->
<!--// this.iframeurl = `/api/exportCsv?structure=${structure}&name=${name}`-->
<!--      const { structure, name } = this.form;-->
<!--      this.iframeurl = `/api/exportCsv?structure=${structure}&name=${name}`;-->
<!--    },-->
<!--    async downloadFile(){-->
<!--      const { structure, name } = this.form;-->
<!--      const URL = `/api/exportCsv?structure=${structure}&name=${name}`-->
<!--      const res = await this.$http.get(URL);-->
<!--      const blob = new Blob([res.data], {type: res.headers['content-type']});-->
<!--      let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");-->
<!--      let result = patt.exec(res.headers['content-disposition']);-->
<!--      let filename = 'result.csv';-->

<!--      const downloadElement = document.createElement('a');-->
<!--      const href = window.URL.createObjectURL(blob);-->

<!--      console.log(filename);-->
<!--      downloadElement.style.display = 'none';-->
<!--      downloadElement.href = href;-->
<!--downloadElement.download = filename ; //下载后文件名-->
<!--      document.body.appendChild(downloadElement);-->
<!--downloadElement.click(); //点击下载-->
<!--document.body.removeChild(downloadElement); //下载完成移除元素-->
<!--window.URL.revokeObjectURL(href); //释放掉blob对象-->
<!--},-->
<!--    toDetail(id) {-->
<!--      const { origin, pathname } = window.location;-->
<!--      window.open(`${origin}${pathname}#/main/search/detail?id=${id}`);-->
<!--    },-->
<!--    toAbout(id) {-->
<!--      const { origin, pathname } = window.location;-->
<!--      window.open(`${origin}${pathname}#/main/search/about?id=${id}`);-->
<!--    },-->
<!--  },-->
<!--  mounted() {-->
<!--     this.onSubmit()-->
<!--  }-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--  .page-warp {-->
<!--    margin-top: 10px;-->
<!--    display: flex;-->
<!--    justify-content: center;-->
<!--  }-->
<!--  .down-load {-->
<!--    display: flex;-->
<!--    justify-content: flex-end;-->
<!--  }-->
<!--  .demo-table-expand {-->
<!--    font-size: 0;-->
<!--  }-->
<!--  .demo-table-expand label {-->
<!--    width: 90px;-->
<!--    color: #99a9bf;-->
<!--  }-->
<!--  .demo-table-expand .el-form-item {-->
<!--    margin-right: 0;-->
<!--    margin-bottom: 0;-->
<!--    width: 50%;-->
<!--  }-->
<!--  .search {-->
<!--    width: 1200px;-->
<!--    margin: 0 auto;-->
<!--  }-->
<!--</style>-->
